export const NAME = 'curriculumStudents';

const SET_CURRICULUM_STUDENTS_FILTERS = `SET_CURRICULUM_STUDENTS_FILTERS_${NAME}`;

export const setCurriculumStudentsFilters = (filters) => ({
	type: SET_CURRICULUM_STUDENTS_FILTERS,
	payload: filters,
});

const filterDefault = {
	curriculumProgramId: null,
	gradeIds: [],
	sectionIds: [],
	searchText: '',
	advancedFilters: [],
	shiftId: null,
	campusId: null,
	activeStatus: 'ACTIVE',
	birthDate: null,
};

const ACTION_MAP = {
	[SET_CURRICULUM_STUDENTS_FILTERS]: (state, action) => ({
		...state,
		filters: {
			...filterDefault,
			...state.filters,
			...action.payload,
		},
	}),
};

const initialState = {
	filters: filterDefault,
};

export const reducer = (state = initialState, action) => {
	const actionFunc = ACTION_MAP[action.type];
	return actionFunc ? actionFunc(state, action) : state;
};
